// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "main[data-v-4d3fca6a]{flex:1;max-width:24rem;width:100%}form[data-v-4d3fca6a]{margin-top:1rem;padding:0 2rem;width:100%}header[data-v-4d3fca6a]{margin-top:1.5rem}.join-button[data-v-4d3fca6a]{margin-top:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
